import { createSelector } from '@reduxjs/toolkit';
import { getSearchText, getSearchUploadData, getSimilarAsset } from '../search/selectors';
import { getSelectedIds as getSelectedTagIds } from '../tag/selectors';
import { getSelectedIds as getSelectedExtensionIds } from '../extension/selectors';
import { ALL_EXTENSIONS_ID } from '../extension/model';
import { getCreative } from '../viewer/selectors';
import { getData, getLoading } from '../finder/selectors';
import { Loading } from '../finder/model';
import { getUploadToProjectEnabled } from './selectors';

// Search / tags / file types / creative narrow the catalog: an empty result then means
// "nothing matched" rather than "nothing uploaded yet". The category is not a filter
// here — an empty folder is still a place to upload to.
export const getCatalogFiltered = createSelector(
  [
    getSearchText,
    getSearchUploadData,
    getSimilarAsset,
    getSelectedTagIds,
    getSelectedExtensionIds,
    getCreative,
  ],
  (searchText, searchUploadData, similarAsset, tagIds, extensionIds, creative) =>
    Boolean(searchText) ||
    Boolean(searchUploadData) ||
    Boolean(similarAsset) ||
    tagIds.length > 0 ||
    // "All types" is the pseudo-id ALL_EXTENSIONS_ID, not a filter.
    extensionIds.some((id) => id !== ALL_EXTENSIONS_ID) ||
    creative !== undefined,
);

// The catalog shows the inline upload panel (EmptyCatalogUpload) instead of results.
export const getEmptyCatalogUploadVisible = createSelector(
  [getData, getLoading, getCatalogFiltered, getUploadToProjectEnabled],
  ({ total }, loading, filtered, enabled) =>
    total.read.count === 0 && loading === Loading.none && !filtered && enabled,
);
